import * as React from 'react';
import ModalForm from './ModalForm';
import {notify} from "../../Utils";

class RateInfo extends React.Component<any, any> {
    state = {
        isLoading: false,
        rate: null
    }

    handlerClick = () => {
        this.setState({isLoading: true, rate: null});
        this.props.onPlageSearch({
            success: (data) => {
                this.setState({isLoading: false, rate: data.originality_rating});
            },
            error: (data) => {
                notify(`Произошла ошибка ${data.status}. Просьба сообщить об ошибке на sitehelp@sk.ru`);
                this.setState({isLoading: false, rate: null});
            }
        })
    }

    render() {
        return (
            <div>
                {/* @ts-ignore */}
                <ModalForm
                    isOpen={this.props.show}
                    onRequestClose={this.props.onHide}
                    modalHeader={
                        <div>Оценить оригинальность</div>
                    }
                    modalFooter={
                        <>
                            <button
                                className="btn btn-primary"
                                onClick={this.handlerClick}
                                disabled={this.state.isLoading}
                            >
                                Оценить
                            </button>
                            <button className="btn btn-default" onClick={this.props.onHide}>Отмена</button>
                        </>
                    }
                >
                    <p>
                        Нажимая кнопку «Оценить», Вы можете запросить оценку
                        оригинальности Вашей заявки, которая проводится на основе текстового
                        анализа со всеми заявками, рассмотренными Фондом «Сколково» ранее.
                        Результатом анализа является оценка в % степени уникальности в
                        сравнении с проектами на аналогичную тему, если такие будут найдены в
                        базе заявок, полученных Фондом «Сколково». Данная оценка носит
                    </p>

                    <p>
                        информационный характер и не отражает вероятность получения
                        положительного либо отрицательного результата экспертизы
                    </p>

                    <p>
                        {this.state.rate && (
                            <span>Оригинальность <b>${this.state.rate}</b></span>
                        )}
                    </p>
                </ModalForm>
            </div>
        )
    }
}

export default RateInfo;
